import { rect, cRect, mRect, px } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Golem — stocky humanoid construct of stone/metal, front-facing.
// Head y=12..21, neck y=22..23, torso y=24..41, hips y=42..43, legs y=44..57.
// Single-frame, no animation.
export const golem: Hull = {
  id: 'golem',
  name: 'Golem',
  baseStats: { ferocity: 25, agility: 5, arcane: 10, resilience: 40, stealth: 5 },
  drawBody: (ctx, p) => {
    // Head (square/trapezoidal)
    cRect(ctx, 12, 12, 10, p.metal);
    cRect(ctx, 12, 12, 1, p.metalLight);   // top highlight
    cRect(ctx, 21, 12, 1, p.metalDark);    // bottom shadow
    rect(ctx, 26, 12, 1, 10, p.metalLight); // left edge
    rect(ctx, 37, 12, 1, 10, p.metalDark);  // right edge
    // Eyes (deep glowing sockets)
    rect(ctx, 28, 16, 3, 3, p.dark);
    rect(ctx, 33, 16, 3, 3, p.dark);
    px(ctx, 29, 17, p.accent);
    px(ctx, 34, 17, p.accent);
    // Neck/shoulders join
    rect(ctx, 26, 22, 12, 2, p.metalDark);
    // Torso (block)
    cRect(ctx, 24, 24, 18, p.metal);
    cRect(ctx, 24, 24, 1, p.metalLight);
    cRect(ctx, 41, 24, 1, p.metalDark);
    rect(ctx, 20, 24, 1, 18, p.metalLight);
    rect(ctx, 43, 24, 1, 18, p.metalDark);
    // Glowing rune seam down the chest (vertical line)
    rect(ctx, 31, 26, 2, 12, p.accent);
    rect(ctx, 31, 30, 2, 2, p.detail);  // brighter rune mark
    // Stubby arms (left + right)
    mRect(ctx, 12, 26, 4, 14, p.metal);
    rect(ctx, 16, 26, 1, 14, p.metalLight);
    rect(ctx, 19, 26, 1, 14, p.metalDark);
    rect(ctx, 44, 26, 1, 14, p.metalLight);
    rect(ctx, 47, 26, 1, 14, p.metalDark);
    // Hand blocks
    rect(ctx, 16, 38, 4, 4, p.metalDark);
    rect(ctx, 44, 38, 4, 4, p.metalDark);
    // Hips
    rect(ctx, 22, 42, 20, 2, p.metalDark);
    // Legs (thick) — left
    rect(ctx, 22, 44, 8, 14, p.metal);
    rect(ctx, 22, 44, 1, 14, p.metalLight);
    rect(ctx, 29, 44, 1, 14, p.metalDark);
    rect(ctx, 22, 56, 8, 2, p.metalDark);  // foot block
    // Legs — right
    rect(ctx, 34, 44, 8, 14, p.metal);
    rect(ctx, 34, 44, 1, 14, p.metalLight);
    rect(ctx, 41, 44, 1, 14, p.metalDark);
    rect(ctx, 34, 56, 8, 2, p.metalDark);  // foot block
  },
  mounts: {
    [SLOT.CRANIUM]: { anchor: { x: 32, y: 12 } },
    [SLOT.BACK]:    { anchor: { x: 28, y: 30 } },
    [SLOT.TAIL]:    { anchor: { x: 50, y: 36 } },
  },
};
